var g_cartContents = { };
var g_personalisationOptionsByKey = { };

function HandlePersonalisationQuantityChanged( )
{
    var qty       = Number( document.querySelector( "form[action='/cart/add'] input[name='quantity']" ).value );
    var blocks    = document.querySelectorAll( "#product-personalisation-block .product-personalisation-options" );
    var template  = document.getElementById( "main-product-personalisation-options" );
    var numBlocks = blocks.length;

    while ( numBlocks < qty )
    {
        var clone = template.cloneNode( true );
        clone.removeAttribute( "id" );
        clone.querySelector( "input.product-personalisation-option" ).value = "";

        blocks[ 0 ].parentNode.appendChild( clone );
        numBlocks++;
    }
    while ( numBlocks > qty )
    {
        numBlocks--;
        blocks[ numBlocks ].remove( );
    }    
}

function SelectedVID( )
{
    var vid;
    var masterSelect = document.querySelector( "form[action='/cart/add'] select[name='id']" );
    if ( masterSelect )
    {
        vid = masterSelect.options[ masterSelect.selectedIndex ].value;
    }
    else
    {
        var inp = document.querySelector( "product-form form input[name='id']" );
        vid = inp.value;
    }
    return ( vid );
}

function HandlePersonalisedATC( e )
{
    e.preventDefault( );
    e.stopPropagation( );

    var id           = SelectedVID( );
    var payload      = { "items" : [ ] };
    var blocks       = document.querySelectorAll( "#product-personalisation-block .product-personalisation-options" );
    var previewData  = document.querySelectorAll( ".personalisation_copy .lluk-editable" );
    var ok           = true;

    if ( ( previewData ) && ( previewData.length > 0 ) )
    {
        var keys = { };
        previewData.forEach( function( e )
        {
            var key = e.getAttribute( "data-key" );
            keys[ key ] = document.querySelector( `input.product-personalisation-option[name='${key}']` ).value;
            if ( keys[ key ] )
            {
            }
            else
            {
                ok = false;
            }
        } );

        if ( ok )
        {
            var add = { "id" : id, "quantity" : 1, "properties" : { } };
            for ( var key in keys )
            {
                add.properties[ key ] = keys[ key ];
            }
            payload.items.push( add );
        }
        else
        {
            var msg = document.getElementById( "personalisation-preview-error" );
            msg.classList.remove( "hidden" );
            //msg.scrollIntoView( { "behavior" : "smooth", "block" : "center" } );
        }
    }
    else
    {
        blocks.forEach( function( block )
        {
            var add      = { "id" : id, "quantity" : 1, "properties" : { } };
            var elements = block.querySelectorAll( "input.product-personalisation-option" );
            elements.forEach( function( element )
            {
                if ( element.value )
                {
                    element.parentNode.querySelector( ".error-message").setAttribute( "style", "display: none;" );
                    var name = element.getAttribute( "name" );
                    add.properties[ name ] = element.value;
                }
                else 
                {
                    element.parentNode.querySelector( ".error-message").removeAttribute( "style" );
                    ok = false;
                }
            } );

            payload.items.push( add );
        } );
    }

    if ( ok )
    {
      var url     = window.Shopify.routes.root + "cart/add.js";
      var options = { "method" : "POST", "headers" : { "content-type" : "application/json" }, "body" : JSON.stringify( payload ) };
      fetch( url, options ).then( function( result )
      {
          var msg = document.getElementById( "personalisation-preview-error" );
        
          if ( msg )
          {
            msg.classList.add( "hidden" );
          }

          if ( ( previewData ) && ( previewData.length > 0 ) )
          {
              window.location.reload();
          }
          else
          {
              window.location = window.Shopify.routes.root + "cart";
          }

      } ).catch( function( error ) 
      {
        console.log( "add failed : ", error );
      } );
    }
}

function RunReplace( src, getter )
{
    var result = "";
    var idx    = 0;
    var length = src.length;
    while ( idx < length )
    {
        var start = src.indexOf( "{{", idx );
        if ( start < 0 )
        {
            result += src.substr( idx );
            break;
        }
        var tokenStart = start + 2;
        var end = src.indexOf( "}}", tokenStart );
        if ( end < 0 )
        {
            result += src.substr( idx );
            break;
        }

        var tokens      = src.substr( tokenStart, end - tokenStart ).trim( );
        var replacement = getter( tokens );

        result += src.substr( idx, start - idx );
        result += replacement;

        idx = end + 2;
    }

    return ( result );

}

function DoReplacements( src, replacements )
{
    var result = RunReplace( src, function( tokens )
    {
        var replacement = replacements[ tokens ];
        if ( replacement == undefined )
        {
            replacement = "";            
        }
        var result;

        var config = g_personalisationOptionsByKey[ tokens ];
        if ( config )
        {
            if ( config.type == "select" )
            {
                var optName = "choose...";
                if ( g_personalisationOptionsByKey[ tokens ].prompt )
                {
                  optName = g_personalisationOptionsByKey[ tokens ].prompt;
                }
              
                result = `<span class="lluk-personalisation-select-wrapper lluk-highlight-wrapper">
                          <select class='lluk-editable lluk-highlighted' data-key="${tokens}"><option value="choose">${optName}</option>`;
                config.options.forEach( function( option )
                { 
                    result += `<option value='${option}'>${option}</option>`;
                } );
                result += "</select></span>";
            }
            else
            {
                var max = config.max ? config.max : -1;
                var cls = "lluk-editable lluk-highlighted";

                if ( ( replacement == "" ) && ( config.prompt ) )
                {
                    replacement = config.prompt;
                    cls += " lluk-editable-prompted";
                }
                
                result = `<span contenteditable class='${cls}' data-max=${max} data-key="${tokens}">${replacement}</span>`;
            }
        }
        else
        {
            result = `<span contenteditable class='lluk-editable lluk-highlighted' data-key="${tokens}">${replacement}</span>`;
        }
        return ( result );
    } );

    return ( result );
}

function DOMApply( root, selector, op )
{
    var elements = root.querySelectorAll( selector );
    elements.forEach( function( element )
    {
        op( element );
    } );
}
function PromptSelected( e )
{
    var element = e.currentTarget;

    if ( element.classList.contains( "lluk-editable-prompted" ) )
    {
        e.preventDefault( );
        e.stopPropagation( );

        element.setAttribute( "style", "width: " + element.offsetWidth + "px;" );
        element.focus( );

        element.classList.remove( "lluk-editable-prompted" );
        //element.innerHTML = "";
        setTimeout( function( ) { element.innerHTML = ""; element.removeAttribute( "style" ); }, 100 ); // hacktastic !

        var key      = element.getAttribute( "data-key" );
        var selector = selector = `.lluk-editable[data-key='${key}']`
        var parent   = document.getElementById( "personalisation-preview-content" );

        DOMApply( parent, selector, function( other )
        {
            if ( other != element )
            {
                other.classList.remove( "lluk-editable-prompted" );
                other.innerHTML = "";
            }
        } );
    }
}


    
function ContentChanged( e )
{
    var element  = e.currentTarget;
    var key      = element.getAttribute( "data-key" );
    var selector = `.product-personalisation-option[name="${key}"]`;
    var property = document.querySelector( selector );
    var parent   = document.getElementById( "personalisation-preview-content" );
    var previous = element.getAttribute( "data-previous" );
    var max      = element.getAttribute( "data-max" );
    var accept   = true;

    if ( max != undefined )
    {
        var txt = element.innerText;
        if ( txt.length > Number( max ) )
        {
            accept = false;
        }
    }

    if ( accept )
    {
        if ( property )
        {
            if ( element.tagName == "SELECT" )
            {
                var value = element.options[ element.selectedIndex ].value;

                if ( value == "choose")
                {
                  
                }
                else
                {
                    property.value = value;

                    if ( element.options[ 0 ].value == "choose" )
                    {
                      element.options[ 0 ].remove( );
                    }
                }
            }
            else
            {
                property.value = element.innerText;
                element.setAttribute( "data-previous", element.innerText );
            }
        }

        selector = `.lluk-editable[data-key='${key}']`;
        DOMApply( parent, selector, function( e )
        {
            if ( e != element )
            {
                if ( e.tagName == "SELECT" )
                {
                    for ( var i = 0; i < e.options.length; i++ )
                    {
                        if ( e.options[ i ].value == property.value )
                        {
                            e.selectedIndex = i;
                            break;
                        }
                    }
                }
                else
                {
                    e.innerHTML = property.value;
                }
            }
        } );

        if ( element.innerHTML == "" )
        {
            element.style["min-width"] = "25px";
            //element.removeAttribute( "style" );
        }
        else
        {
            element.style["min-width"] = "unset";
            //element.setAttribute( "style", "min-width: unset;" );
        }
    }
    else
    {
        element.innerHTML = previous;
    }
}
function HidePreview( e )
{
    var container = document.getElementById( "personalisation-preview-container" );
    container.classList.remove( "personalisation-preview-container-visible" );
}
function PreviewFontChanged( )
{
    var checked   = document.getElementById( "preview-font-control" ).checked;
    var container = document.getElementById( "personalisation-preview-container-inner" );

    if ( checked )
    {
        container.classList.add( "show-final-font" );
    }
    else
    {
        container.classList.remove( "show-final-font" );
    }
}


function ShowPreview( e )
{
    var container        = document.getElementById( "personalisation-preview-container" );
    var selectedVID      = SelectedVID( );
    var blocks           = document.querySelectorAll( "#product-personalisation-block .product-personalisation-options" );
    var swaps            = { };
    var ok               = true;

    blocks.forEach( function( block )
    {
        var elements = block.querySelectorAll( "input.product-personalisation-option" );
        elements.forEach( function( element )
        {
            if ( element.value )
            {
                element.parentNode.querySelector( ".error-message").setAttribute( "style", "display: none;" );
                var name = element.getAttribute( "name" );
                swaps[ name ] = element.value;
            }
            //else 
            //{
            //    element.parentNode.querySelector( ".error-message").removeAttribute( "style" );
            //    ok = false;
            //}
        } );
    } );

    if ( ok )
    {
        var cfg    = g_personalisationPreviewLookup[ selectedVID ];
        var target = document.getElementById( "personalisation-preview-content" );
        while ( target.firstChild ) { target.firstChild.remove( ); }

        cfg.forEach( function( thing )
        {
            var header = document.createElement( "img" );
            var footer = document.createElement( "img" );
            var copy   = document.createElement( "p" );

            copy.setAttribute( "class", "personalisation_copy" );
            footer.setAttribute( "src", thing.footer );
            header.setAttribute( "src", thing.header );

            var show = DoReplacements( thing.copy, swaps );
            copy.innerHTML = show;

            target.appendChild( header );
            target.appendChild( copy );
            target.appendChild( footer );
        } );
        
        DOMApply( target, ".lluk-editable", function( e ) { e.addEventListener( "input", ContentChanged ); } );
        DOMApply( target, ".lluk-editable-prompted", function( e ) { e.addEventListener( "focus", PromptSelected ); } );
        
        var y = window.scrollY;
        if ( y < 80 )
        {
            y = 80;
        }
        
        container.setAttribute( "style", "height:" + document.body.clientHeight + "px;" );
        container.querySelector( "#personalisation-preview-container-inner" ).setAttribute( "style", "top:" + y + "px;" );
        container.classList.add( "personalisation-preview-container-visible" );
    }
}

function RefreshCart( cb )
{
    var xhr = new XMLHttpRequest( );

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                {
                    try
                    {
                        g_cartContents = JSON.parse( xhr.responseText );
                        cb( g_cartContents );
                    }
                    catch ( e )
                    {
                        console.log( "error parsing response : " + e.stack );
                    }
                }
            }
        }
    };


    xhr.open( "GET", "/cart.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( );
}


function ChooseVariant( )
{
    RefreshCart( function( cart )
    {
        var counts = { };
        for ( var vid in g_personalisationPreviewLookup )
        {
            counts[ vid ] = 0;
        }
        if ( ( cart ) && ( cart.items ) )
        {
            cart.items.forEach( function( item )
            {
                var vid = item.variant_id.toString( );
                if ( counts[ vid ] != undefined )
                {
                    counts[ vid ]++;
                }
            } );

            var lowest;
            var lowestValue;
            for ( vid in counts )
            {
                if ( lowest == undefined )
                {
                    lowest = vid;
                    lowestValue = counts[ vid ];
                }
                else if ( counts[ vid ] < lowestValue )
                {
                    lowest = vid;
                    lowestValue = counts[ vid ];
                }
            }
            if ( lowest )
            {
                var masterSelect = document.querySelector( "form[action='/cart/add'] select[name='id']" );
                if ( masterSelect )
                {
                    for ( var i = 0; i < masterSelect.options.length; i++ )
                    {
                        if ( masterSelect.options[ i ].value == lowest )
                        {
                            masterSelect.selectedIndex = i;
                            break;
                        }
                    }
                }
                else
                {
                    var pf = document.querySelector( "product-form form" );
                    var inp = pf.querySelector( "input[name='id']" );
                    if ( inp )
                    {
                        inp.value = lowest;
                    }
                    else
                    {
                        inp = document.createElement( "input" );
                        inp.setAttribute( "type", "hidden" );
                        inp.setAttribute( "style", "display: none;" );
                        inp.setAttribute( "name", "id" );
                        inp.value = lowest;
                        pf.appendChild( inp );
                    }
                }
            }
            else
            {
                console.log( "error - failed to find a variant" );
            }
        }
    } );
}

function SetupPersonalisationOptionsFromMetafields( options )
{
    var target = document.getElementById( "product-personalisation-options" );
    options.forEach( function( option )
    {
        g_personalisationOptionsByKey[ option.name ] = option;

        var add = document.createElement( "tr" );

        add.innerHTML = `<td><span>${option.name}</span></td>
                         <td><input type="text" class="product-personalisation-option" name="${option.name}" >
                                <p style="display: none;" class="error-message">Please enter a value</p></td</tr>`
            
        target.appendChild( add );
    } );
    
}

function SetupPersonalisationDOM( )
{
    var qty = document.querySelector( "form[action='/cart/add'] input[name='quantity']" );
    if ( qty )
    {
        qty.addEventListener( "input", HandlePersonalisationQuantityChanged );
    }
    var boxes = document.querySelectorAll( "form[action='/cart/add'] a[data-quantity]" );
    boxes.forEach( function( box )
    {
        box.addEventListener( "click",
        function( )
        {
            setTimeout( HandlePersonalisationQuantityChanged, 1 );
        } );
    } );

    var atc = document.querySelector( "form[action='/cart/add'] button[type='submit']" );
    if ( atc )
    {
        atc.addEventListener( "click", HandlePersonalisedATC );
    }
    var atc2 = document.querySelector( "#lluk-personalised-atc" );
    if ( atc2 )
    {
        atc2.addEventListener( "click", HandlePersonalisedATC );
    }

    var preview = document.getElementById( "show-personalisation_preview" );
    if ( preview )
    {
        preview.addEventListener( "click", ShowPreview );
        document.getElementById( "close-personalisation_preview" ).addEventListener( "click", HidePreview );

        var atcButton   = document.querySelector( "form[action='/cart/add'] .product__submit" );
        var productForm = atcButton.closest( "product-form" );
        var previewRow  = document.querySelector( "#personalisation-preview-container-inner .personalisation-preview-button-row" );
        //previewRow.appendChild( productForm );

        var container = document.getElementById( "personalisation-preview-container" );
        container.setAttribute( "style", "height:" + document.body.clientHeight + "px;" );
        document.body.insertBefore( container, document.body.firstChild );

        ChooseVariant( );

        var box = document.getElementById( "preview-font-control" );
        if ( box )
        {
            box.addEventListener( "change", PreviewFontChanged );
        }
    }

    if ( g_personalisationOptions )
    {
        SetupPersonalisationOptionsFromMetafields( g_personalisationOptions );
    }
}

function StartupPersonalisation( )
{
    console.log( "personalisation starting" );

    window.addEventListener( "load", SetupPersonalisationDOM );
}
StartupPersonalisation( );
